import * as yup from 'yup';
import i18n from '../../../../localization/i18n';
import { isSiteCanadian } from '../../../../utils/helpers';
import { validateBirth } from '../utils';
import {
    CREDIT_APPLICANT_ADDRESS1_ERROR,
    CREDIT_APPLICANT_ADRESSMONTH_ERROR,
    CREDIT_APPLICANT_ADRESSYEAR_ERROR,
    CREDIT_APPLICANT_BIRTHDATE_ERROR,
    CREDIT_APPLICANT_CELLPHONE_ERROR,
    CREDIT_APPLICANT_CITY_ERROR,
    CREDIT_APPLICANT_EMAIL_ERROR,
    CREDIT_APPLICANT_FIRSTNAME_ERROR,
    CREDIT_APPLICANT_HOMEPHONE_ERROR,
    CREDIT_APPLICANT_IDNUMBER_CA_ERROR,
    CREDIT_APPLICANT_IDNUMBER_US_BUSINESS_ERROR,
    CREDIT_APPLICANT_IDNUMBER_US_ERROR,
    CREDIT_APPLICANT_LASTNAME_ERROR,
    CREDIT_APPLICANT_MI_ERROR,
    CREDIT_APPLICANT_PREVACC_ERROR,
    CREDIT_APPLICANT_WORKPHONE_ERROR,
    CREDIT_APPLICANT_ZIP_CA_ERROR,
    CREDIT_APPLICANT_ZIP_US_ERROR,
    LABEL_FIELD_ERROR_REQUIRED_VALID,
} from '../../../../localization/resouceKeys';

const isCanada = isSiteCanadian();

const MAXADDRESS = 40;
const MINADDRESS = 2;
const MAXADDRESS2 = 25;
const MAXEMAIL = 50;
const MAXACCOUNTNUMBER = 10;
const MAXCITY = 30;
const CERO = 0;
const MAXYEARS = 99;
const MAXMONTHS = 11;

export const businessIdentificationNumberValidation = yup
    .string()
    .matches(
        /^(?!00-0000000$)(?!11-1111111$)(?!22-2222222$)(?!33-3333333$)(?!44-4444444$)(?!55-5555555$)(?!66-6666666$)(?!77-7777777$)(?!88-8888888$)(?!99-9999999$)(?!12-3456789$)\d{2}-\d{7}$/,
        {
            excludeEmptyString: true,
            message: () => i18n.t(CREDIT_APPLICANT_IDNUMBER_US_BUSINESS_ERROR),
        },
    );

const countryBasedValidations = () => {
    if (isCanada) {
        return {
            identificationNumber: yup.string().matches(
                // eslint-disable-next-line max-len
                /^(?!000-000-000)(?!111-111-111)(?!222-222-222)(?!333-333-333)(?!444-444-444)(?!555-555-555)(?!666-666-666)(?!777-777-777)(?!888-888-888)(?!123-456-789)(\d{3}-\d{3}-\d{3})$/i,
                () => i18n.t(CREDIT_APPLICANT_IDNUMBER_CA_ERROR),
            ),
            zipOrPostalCode: yup
                .string()
                .required(() => i18n.t(CREDIT_APPLICANT_ZIP_CA_ERROR))
                .matches(
                    // eslint-disable-next-line max-len
                    /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
                    () => i18n.t(CREDIT_APPLICANT_ZIP_CA_ERROR),
                ),
            telePhoneHome: yup.string().matches(
                // eslint-disable-next-line max-len
                /^(?!\(000\)\s000-0000)(?!\(111\)\s111-1111)(?!\(222\)\s222-2222)(?!\(333\)\s333-3333)(?!\(444\)\s444-4444)(?!\(555\)\s555-5555)(?!\(666\)\s666-6666)(?!\(777\)\s777-7777)(?!\(888\)\s888-8888)(?!\(999\)\s999-9999)(\(\d{3}\)\s\d{3}-\d{4})$/i,
                {
                    excludeEmptyString: true,
                    message: () => i18n.t(CREDIT_APPLICANT_HOMEPHONE_ERROR),
                },
            ),
            telePhoneWork: yup.string().matches(
                // eslint-disable-next-line max-len
                /^(?!\(000\)\s000-0000)(?!\(111\)\s111-1111)(?!\(222\)\s222-2222)(?!\(333\)\s333-3333)(?!\(444\)\s444-4444)(?!\(555\)\s555-5555)(?!\(666\)\s666-6666)(?!\(777\)\s777-7777)(?!\(888\)\s888-8888)(?!\(999\)\s999-9999)(\(\d{3}\)\s\d{3}-\d{4})$/i,
                {
                    excludeEmptyString: true,
                    message: () => i18n.t(CREDIT_APPLICANT_WORKPHONE_ERROR),
                },
            ),
            cellPhoneNumber: yup.string().matches(
                // eslint-disable-next-line max-len
                /^(?!\(000\)\s000-0000)(?!\(111\)\s111-1111)(?!\(222\)\s222-2222)(?!\(333\)\s333-3333)(?!\(444\)\s444-4444)(?!\(555\)\s555-5555)(?!\(666\)\s666-6666)(?!\(777\)\s777-7777)(?!\(888\)\s888-8888)(?!\(999\)\s999-9999)(\(\d{3}\)\s\d{3}-\d{4})$/i,
                {
                    excludeEmptyString: true,
                    message: () => i18n.t(CREDIT_APPLICANT_CELLPHONE_ERROR),
                },
            ),
        };
    } else {
        const idNumberError = () => i18n.t(CREDIT_APPLICANT_IDNUMBER_US_ERROR);
        const usIdNumberRegex =
            /^(?!000-00-0000)(?!111-11-1111)(?!222-22-2222)(?!333-33-3333)(?!444-44-4444)(?!555-55-5555)(?!666-66-6666)(?!777-77-7777)(?!888-88-8888)(?!123-45-6789)(\d{3}-\d{2}-\d{4})$/i;
        return {
            identificationNumber: yup
                .string()
                .required(idNumberError)
                .matches(usIdNumberRegex, idNumberError),
            zipOrPostalCode: yup
                .string()
                .required(() => i18n.t(CREDIT_APPLICANT_ZIP_US_ERROR))
                .matches(
                    // eslint-disable-next-line max-len
                    /^(?!00000)(^\d{5})+(-\d{4})*$/i,
                    () => i18n.t(CREDIT_APPLICANT_ZIP_US_ERROR),
                ),
            telePhoneHome: yup.string().matches(
                // eslint-disable-next-line max-len
                /^(?!\(000\)\s000-0000)(?!\(111\)\s111-1111)(?!\(222\)\s222-2222)(?!\(333\)\s333-3333)(?!\(444\)\s444-4444)(?!\(555\)\s555-5555)(?!\(666\)\s666-6666)(?!\(777\)\s777-7777)(?!\(888\)\s888-8888)(?!\(999\)\s999-9999)(\(\d{3}\)\s\d{3}-\d{4})$/i,
                {
                    excludeEmptyString: true,
                    message: () => i18n.t(CREDIT_APPLICANT_HOMEPHONE_ERROR),
                },
            ),
            telePhoneWork: yup.string().matches(
                // eslint-disable-next-line max-len
                /^(?!\(000\)\s000-0000)(?!\(111\)\s111-1111)(?!\(222\)\s222-2222)(?!\(333\)\s333-3333)(?!\(444\)\s444-4444)(?!\(555\)\s555-5555)(?!\(666\)\s666-6666)(?!\(777\)\s777-7777)(?!\(888\)\s888-8888)(?!\(999\)\s999-9999)(\(\d{3}\)\s\d{3}-\d{4})$/i,
                {
                    excludeEmptyString: true,
                    message: () => i18n.t(CREDIT_APPLICANT_WORKPHONE_ERROR),
                },
            ),
            cellPhoneNumber: yup.string().matches(
                // eslint-disable-next-line max-len
                /^(?!\(000\)\s000-0000)(?!\(111\)\s111-1111)(?!\(222\)\s222-2222)(?!\(333\)\s333-3333)(?!\(444\)\s444-4444)(?!\(555\)\s555-5555)(?!\(666\)\s666-6666)(?!\(777\)\s777-7777)(?!\(888\)\s888-8888)(?!\(999\)\s999-9999)(\(\d{3}\)\s\d{3}-\d{4})$/i,
                {
                    excludeEmptyString: true,
                    message: () => i18n.t(CREDIT_APPLICANT_CELLPHONE_ERROR),
                },
            ),
        };
    }
};

const completeObjectValidation = {
    firstName: yup
        .string()
        .required(() => i18n.t(CREDIT_APPLICANT_FIRSTNAME_ERROR))
        .matches(
            // eslint-disable-next-line max-len
            /^(\D){1,30}$/i,
            () => i18n.t(CREDIT_APPLICANT_FIRSTNAME_ERROR),
        ),
    middleInitial: yup.string().matches(
        // eslint-disable-next-line max-len
        /^(\D)$/i,
        () => i18n.t(CREDIT_APPLICANT_MI_ERROR),
    ),
    lastName: yup
        .string()
        .required(() => i18n.t(CREDIT_APPLICANT_LASTNAME_ERROR))
        .matches(
            // eslint-disable-next-line max-len
            /^(\D){1,30}$/i,
            () => i18n.t(CREDIT_APPLICANT_LASTNAME_ERROR),
        ),
    dateOfBirth: yup
        .string()
        .required(() => i18n.t(CREDIT_APPLICANT_BIRTHDATE_ERROR))
        .test(
            'dob',
            () => i18n.t(CREDIT_APPLICANT_BIRTHDATE_ERROR),
            (v) => validateBirth(v ?? ''),
        ),
    addressLine1: yup
        .string()
        .transform((v) => v.trim())
        .required(() => i18n.t(CREDIT_APPLICANT_ADDRESS1_ERROR))
        .min(MINADDRESS, () => i18n.t(CREDIT_APPLICANT_ADDRESS1_ERROR))
        .max(MAXADDRESS, () => i18n.t(CREDIT_APPLICANT_ADDRESS1_ERROR)),
    addressLine2: yup
        .string()
        .transform((v) => v.trim())
        .max(MAXADDRESS2, () => i18n.t(CREDIT_APPLICANT_ADDRESS1_ERROR)),
    city: yup
        .string()
        .transform((v) => v.trim())
        .required(() => i18n.t(CREDIT_APPLICANT_CITY_ERROR))
        .max(MAXCITY),
    timeAtAddrYears: yup
        .number()
        .required(() => i18n.t(CREDIT_APPLICANT_ADRESSYEAR_ERROR))
        .min(CERO, () => i18n.t(CREDIT_APPLICANT_ADRESSYEAR_ERROR))
        .max(MAXYEARS, () => i18n.t(CREDIT_APPLICANT_ADRESSYEAR_ERROR)),
    timeAtAddrMonths: yup
        .number()
        .required(() => i18n.t(CREDIT_APPLICANT_ADRESSMONTH_ERROR))
        .min(CERO, () => i18n.t(CREDIT_APPLICANT_ADRESSMONTH_ERROR))
        .max(MAXMONTHS, () => i18n.t(CREDIT_APPLICANT_ADRESSMONTH_ERROR)),
    emailAddress: yup
        .string()
        .transform((v) => v.trim().toLowerCase())
        .required(() => i18n.t(CREDIT_APPLICANT_EMAIL_ERROR))
        .matches(
            // eslint-disable-next-line max-len
            /^([a-zA-Z0-9_\u00C0-\u024F\-.]+)@([a-zA-Z0-9_\u00C0-\u024F\-.]+)\.([a-zA-Z\u00C0-\u024F]{2,63})$/i,
            () => i18n.t(CREDIT_APPLICANT_EMAIL_ERROR),
        )
        .max(MAXEMAIL),
    previousAccountNumber: yup
        .string()
        .matches(
            // eslint-disable-next-line max-len
            /^\d*$/i,
            () => i18n.t(CREDIT_APPLICANT_PREVACC_ERROR),
        )
        .max(MAXACCOUNTNUMBER),
    rentOrMortgagePymyt: yup
        .string()
        .trim()
        .matches(/^(?:\d{1,6})(?:\.\d{1,2})?$/, () =>
            i18n.t(LABEL_FIELD_ERROR_REQUIRED_VALID),
        ),
    quebecMonthlyHoising: yup
        .string()
        .trim()
        .matches(/^(?:\d{1,6})(?:\.\d{1,2})?$/, () =>
            i18n.t(LABEL_FIELD_ERROR_REQUIRED_VALID),
        ),
    quebeckMonthlyMortgage: yup
        .string()
        .trim()
        .matches(/^(?:\d{1,6})(?:\.\d{1,2})?$/, () =>
            i18n.t(LABEL_FIELD_ERROR_REQUIRED_VALID),
        ),
    previousAddressLine1: yup
        .string()
        .transform((v) => v.trim())
        .min(MINADDRESS, () => i18n.t(CREDIT_APPLICANT_ADDRESS1_ERROR))
        .max(MAXADDRESS),
    previousAddressLine2: yup
        .string()
        .transform((v) => v.trim())
        .max(MAXADDRESS2),
    previousCity: yup
        .string()
        .transform((v) => v.trim())
        .max(MAXCITY),
    previousTimeAtAddrYears: yup
        .number()
        .min(CERO, () => i18n.t(CREDIT_APPLICANT_ADRESSYEAR_ERROR))
        .max(MAXYEARS, () => i18n.t(CREDIT_APPLICANT_ADRESSYEAR_ERROR)),
    previousTimeAtAddrMonths: yup
        .number()
        .min(CERO, () => i18n.t(CREDIT_APPLICANT_ADRESSMONTH_ERROR))
        .max(MAXMONTHS, () => i18n.t(CREDIT_APPLICANT_ADRESSMONTH_ERROR)),
    previousRentOrMortgagePymyt: yup
        .string()
        .trim()
        .matches(/^(?:\d{1,6})(?:\.\d{1,2})?$/, () =>
            i18n.t(LABEL_FIELD_ERROR_REQUIRED_VALID),
        ),
    ...countryBasedValidations(),
};

export const getApplicantValidations = () =>
    yup.object().shape({
        ...completeObjectValidation,
        ...countryBasedValidations(),
    });

export const applicantValidations = getApplicantValidations();
